import { Box, Progress } from "@chakra-ui/react";

import { RanaModal } from "@nens/ranalib";

interface ExportLoadingModalProps {
  isOpen: boolean;
  progress: number;
}

export default function ExportLoadingModal({ isOpen, progress }: ExportLoadingModalProps) {
  return (
    <RanaModal isOpen={isOpen} topBar="Exporting">
      <Box mt={2} mb={6}>
        <Progress value={progress} />
      </Box>
    </RanaModal>
  );
}
